import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';

import SearchResultEmpty from 'rebook/apps/search/components/SearchResultEmpty';
import RightholdersList from 'rebook/apps/catalog/components/RightholdersList';
import BackLink from 'rebook/apps/base/components/BackLink';
import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import SpinnerLoader from 'rebook/apps/base/components/SpinnerLoader';
import pluralize from 'rebook/apps/utils/text/pluralize';
import * as SearchRightholdersActions from 'rebook/apps/search/actions/SearchRightholdersActions';

import styles from './style.scss';


class SearchRightholdersView extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.SearchRightholdersActions.fetchInitialData(this.props.location);
  }

  componentWillUnmount() {
    this.props.SearchRightholdersActions.resetData();
  }

  changePage(newPageNumber) {
    this.props.SearchRightholdersActions.fetchRightholders(newPageNumber);
  }

  render() {
    const {
      rightholderList, rightholderCount, query,
      pageNumber, lastPageNumber, isLoading,
    } = this.props.searchRightholders;

    return (
      <div className="backgroundContainer themeGrey">
        <div className="section">
          {isLoading && <SpinnerLoader />}
          {!isLoading && !get(rightholderList, 'length', 0) && <SearchResultEmpty /> }
          {!isLoading && rightholderList && (
            <React.Fragment>
              <BackLink link={`/search/?q=${query}`}
                extraClassName={styles.breadCrumbs}
                isMargined>
                <span className="link">Все результаты</span>
              </BackLink>
              <div className="title-1">Все издатели по запросу «{query}»</div>
              {rightholderCount > 0 && (
                <small>
                  {rightholderCount} {pluralize(rightholderCount, 'издатель', 'издателя', 'издателей') }
                </small>
              )}
              <RightholdersList rightholders={rightholderList} />
              <ContextPagination
                onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
                currentPage={pageNumber}
                lastPage={lastPageNumber} />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => (
  {
    searchRightholders: state.searchRightholders,
  }
);

const mapDispatchToProps = (dispatch) => (
  {
    SearchRightholdersActions: bindActionCreators(SearchRightholdersActions, dispatch),
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(SearchRightholdersView);
